import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { ErrorComponentProps, useRouter } from '@tanstack/react-router';

import InternalErrorBoundary from '@components/internal-error-boundary';
import { captureFrontendException } from '@lib/observability/sentry';

const RouteErrorBoundary = ({ error, reset }: ErrorComponentProps) => {
  const router = useRouter();
  const queryErrorResetBoundary = useQueryErrorResetBoundary();

  const onRetry = () => {
    queryErrorResetBoundary.reset();
    reset();
    router.invalidate().catch((retryError: unknown) => {
      captureFrontendException(retryError);
    });
  };

  return <InternalErrorBoundary error={error} resetErrorBoundary={onRetry} />;
};

export default RouteErrorBoundary;
